var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Track } from "../../../../components";
import { Segment } from "../Segment";
import { StaticProgressbar } from "../StaticProgressbar";
var BetProgress = /** @class */ (function (_super) {
    __extends(BetProgress, _super);
    function BetProgress() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetProgress.prototype.renderSegments = function () {
        return (React.createElement(React.Fragment, null,
            this.props.segments.periods.map(function (x, i) {
                return (React.createElement(Segment, { key: "pb-p-p" + (i + 1), time: x.startTime, index: i + 1 }));
            }),
            React.createElement(Segment, { key: "pb-p-p4", time: this.props.segments.endTime, index: 4 })));
    };
    BetProgress.prototype.render = function () {
        return (React.createElement("div", { className: "rj-pulse-bet__progress-wrapper" },
            !this.props.isProgressFinished
                ? React.createElement(Track, { start: this.props.isGameInProgress, colors: this.props.colors, segments: this.props.segments, callbacks: this.props.callbacks })
                : React.createElement(StaticProgressbar, null),
            this.renderSegments()));
    };
    return BetProgress;
}(React.Component));
export { BetProgress };
//# sourceMappingURL=BetProgress.js.map